import { io } from "socket.io-client";

// const IP_SERVER = "http://127.0.0.1:8003";

const IP_SERVER = `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}`;

export const socketIo = io(IP_SERVER, {
  reconnection: true,
  transports: ["websocket"],
  withCredentials: true,
});
